//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export enum GOOGLE_CATALOG_INGESTION_MODAL_ACTIONS {
  RESET_STATE = 'GOOGLE_CATALOG_INGESTION/RESET_STATE',
  OPEN_MODAL = 'GOOGLE_CATALOG_INGESTION/OPEN_MODAL',
  CLOSE_MODAL = 'GOOGLE_CATALOG_INGESTION/CLOSE_MODAL',
  CHANGE_PANEL = 'GOOGLE_CATALOG_INGESTION/CHANGE_PANEL',
  REQUEST_VALIDATE_SOURCE = 'GOOGLE_CATALOG_INGESTION/REQUEST_VALIDATE_SOURCE',
  RECEIVE_VALIDATE_SOURCE = 'GOOGLE_CATALOG_INGESTION/RECIEVE_VALIDATE_SOURCE',
  SET_VALIDATION_TOKEN = 'GOOGLE_CATALOG_INGESTION/SET_VALIDATION_TOKEN',
  SET_FULL_ERROR_DATA = 'GOOGLE_CATALOG_INGESTION/SET_FULL_ERROR_DATA',
  SET_EXPANDING_ERROR_DATA = 'GOOGLE_CATALOG_INGESTION/SET_EXPANDING_ERROR_DATA',
  REQUEST_IS_SCHEDULING = 'GOOGLE_CATALOG_INGESTION/REQUEST_IS_SCHEDULING',
  RECEIVE_IS_SCHEDULING = 'GOOGLE_CATALOG_INGESTION/RECEIVE_IS_SCHEDULING',
  REQUEST_VALIDATION_STATUS = 'GOOGLE_CATALOG_INGESTION/REQUEST_VALIDATION_STATUS',
  RECEIVE_VALIDATION_STATUS = 'GOOGLE_CATALOG_INGESTION/RECEIVE_VALIDATION_STATUS',
  REQUEST_VALIDATION = 'GOOGLE_CATALOG_INGESTION/REQUEST_VALIDATION',
  RECEIVE_VALIDATION = 'GOOGLE_CATALOG_INGESTION/RECEIVE_VALIDATION',
  GET_VALID_SAMPLE = 'GOOGLE_CATALOG_INGESTION/GET_VALID_SAMPLE',
  RECEIVE_VALID_SAMPLE = 'GOOGLE_CATALOG_INGESTION/RECEIVE_VALID_SAMPLE',
  GET_INVALID_SAMPLE = 'GOOGLE_CATALOG_INGESTION/GET_INVALID_SAMPLE',
  RECEIVE_INVALID_SAMPLE = 'GOOGLE_CATALOG_INGESTION/RECEIVE_INVALID_SAMPLE',
  GET_VALIDATION_RESULTS = 'GOOGLE_CATALOG_INGESTION/GET_VALIDATION_RESULTS',
  RECEIVE_VALIDATION_RESULTS = 'GOOGLE_CATALOG_INGESTION/RECEIVE_VALIDATION_RESULTS',
  ONBOARD_CATALOG = 'GOOGLE_CATALOG_INGESTION/ONBOARD_CATALOG',
  CATALOG_ONBOARDED = 'GOOGLE_CATALOG_INGESTION/CATALOG_ONBOARDED',
}

export enum WORKFLOW_PANELS {
  CONNECT_PANEL = 1,
  REVIEW_PANEL = 2,
  PROCESS_PANEL = 3,
}

export const progressSteps = [
  { stepLabel: 'Connect' },
  { stepLabel: 'Review' },
  { stepLabel: 'Processing' },
];

export const TOTAL_STEPS = 3;
